var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPOIFilter),expression:"showPOIFilter"}],staticClass:"mapboxgl-ctrl mapboxgl-ctrl-group"},[_c('button',{staticClass:"mapboxgl-ctrl-icon",attrs:{"aria-label":"Filter"},on:{"click":function($event){return _vm.$store.dispatch('sightmapevent/inqueueMapEvent', {
      event: 'handleShowSetting'
    })}}},[_c('i',{staticClass:"fas fa-filter",staticStyle:{"transform":"scale(1.1)"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }